import SearchProblem from './SearchProblem';

export default SearchProblem;
